import React from 'react';
import Button from '@material-ui/core/Button';
import DialogS from './DialogS.js';

class DialogContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.reAddItem = this.reAddItem.bind(this);
    this.state = {
      open: false,
      callback: this.props.callback,
      properties: this.props.properties,
      openProperties: []
    };
  }

  reAddItem(item) {
    let currentlyOpenProperties = this.state.openProperties;
    var index = currentlyOpenProperties.indexOf(item);
    currentlyOpenProperties.splice(index, 1);
    this.setState({
      openProperties: currentlyOpenProperties
    })
  }

  handleClickOpen() {
    this.setState({
      open: true
    })
  }

  handleClose(value) {
    this.setState({
      open: false
    })
    if (value) {
      let newProps = this.state.openProperties;
      newProps.push(value);
      this.setState({
        openProperties: newProps
      });
      this.state.callback(value);
    }
  };

  filterProperties() {
    let allProps = this.state.properties;
    let openProps = this.state.openProperties;
    let filtered = allProps.filter(function (i) {
      return !openProps.includes(i);
    });
    return filtered;
  }

  render() {
    if (this.state.properties.length === this.state.openProperties.length) {
      return (<div></div>)
    } else {
      return (
        <div>
          <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
            {this.props.label ? this.props.label : "Add user properties"}
          </Button>
          <DialogS open={this.state.open} onClose={this.handleClose} properties={this.filterProperties()} />
        </div>
      );
    }
  }
}

export default DialogContainer;